import React from 'react';
import { PossibleEnrichments } from '@outdoorly/chat-sdk';
import { MotionBox } from '../Motion';
import { SkeletonImage } from '../SkeletonImage';
import { tryToBuildImgixUrl } from '../../utils/imgix';
import { posthog } from 'posthog-js';

type ExpertProfileAvatarProps = {
  expertProfile: NonNullable<PossibleEnrichments['expert']>['expertProfile'];
  fullscreen: boolean;
  setFullscreen: (isFullscreen: boolean) => void;
};
export const ExpertProfileAvatar: React.FC<ExpertProfileAvatarProps> = (props) => {
  const { expertProfile, fullscreen, setFullscreen } = props;
  return (
    <MotionBox
      width="96px"
      height="96px"
      borderRadius="50%"
      animate={{
        position: fullscreen ? 'absolute' : 'relative',
        left: fullscreen ? '16px' : 'unset',
        top: fullscreen ? '119px' : 'unset'
      }}
      initial={{
        position: 'relative',
        top: 'unset',
        left: 'unset'
      }}
      key={`expert-profile-slide-${fullscreen}-${expertProfile?.id}`}
    >
      <SkeletonImage
        src={tryToBuildImgixUrl(expertProfile?.avatar ?? '', {
          h: 200,
          w: 200,
          auto: 'format,compress',
          crop: 'faces',
          fit: 'crop'
        })}
        imageProps={{
          objectFit: 'cover',
          borderRadius: '50%',
          border: '4px solid white',
          height: '100%',
          width: '100%',
          sx: {
            WebkitUserDrag: 'none',
            WebkitUserSelect: 'none'
          },
          role: 'presentation',
          onClick: () => {
            if (!fullscreen) {
              posthog.capture('VIEW-EXPERT-PROFILE', {
                expert_id: expertProfile?.id,
                expert_name: expertProfile?.publicName
              });
              setFullscreen(true);
            }
          },
          boxSizing: 'border-box',
          cursor: fullscreen ? 'auto' : 'pointer',
          filter: 'drop-shadow(0px 2px 24px rgba(0, 0, 0, 0.2))'
        }}
      />
    </MotionBox>
  );
};
